import {Box, Divider, LinearProgress, Typography} from '@mui/material'
import type {FC} from 'react'
import {useGetEquipmentsWithSearchQuery} from '@apis/base'
import EquipmentCard from '@containers/Dashboards/LinesOverview/equipments/EquipmentCard.tsx'
import ErrorBoundary from '@shared/components/ErrorBoundary.tsx'
import CardViewError from '@shared/components/errors/CardView.tsx'
import HorizonatlScrollingContainer from '@shared/components/HorizontalScrollingContainer.tsx'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation.ts'

interface SearchErpBatchResultsProps {
  searchTerm: string
  productionAreaId?: string
  lineId?: string
  equipmentId?: string
}

const SearchEquipmentResults: FC<SearchErpBatchResultsProps> = ({
  searchTerm,
  productionAreaId,
  lineId,
  equipmentId,
}) => {
  const [t] = useCustomTranslation('common')
  const {
    data: searchEquipmentResults,
    error: searchEquipmentError,
    isFetching: searchEquipmentIsFetching,
  } = useGetEquipmentsWithSearchQuery(
    {search: searchTerm, productionAreaId, lineId, equipmentId},
    {skip: !searchTerm},
  )
  return (
    <Box sx={{p: 1}}>
      {searchEquipmentIsFetching ? (
        <Box>
          <Divider>
            <Typography variant="h6" color="text.secondary" sx={{mb: 1}}>
              {t('appbar_search_equipment.search_running')}
            </Typography>
          </Divider>
          <LinearProgress sx={{width: '100%'}} />
        </Box>
      ) : searchEquipmentResults && searchEquipmentResults.length === 0 && !searchEquipmentError ? (
        <Divider>
          <Typography variant="h6" color="text.secondary" align="left">
            {t('appbar_search_equipment.no_results')}
          </Typography>
        </Divider>
      ) : searchEquipmentResults && !searchEquipmentError ? (
        <>
          <Divider>
            <Typography variant="h6" color="text.secondary" sx={{mb: 1}}>
              {searchEquipmentResults.length} {t('appbar_search_equipment.number_found')}
            </Typography>
          </Divider>
          <HorizonatlScrollingContainer>
            {searchEquipmentResults.map((equipment) => (
              <Box
                key={equipment.id}
                sx={{
                  flex: '0 0 auto',
                  width: 300,
                  padding: 1,
                }}
              >
                <ErrorBoundary fallbackComponent={<CardViewError />}>
                  <EquipmentCard equipment={equipment} showDetails={false} />
                </ErrorBoundary>
              </Box>
            ))}
          </HorizonatlScrollingContainer>
        </>
      ) : (
        t('messages.unexpected_error')
      )}
    </Box>
  )
}

export default SearchEquipmentResults
